import 'telstra-ui/resources/telstraui.css';
import 'telstra-ui/resources/themes/pacific.css';
import { IApplicationDefinition } from '@apps-config/app-definition';
import { enableLogging } from '@utils/logger'
import { Application } from '@applications/ops-hub';
import { reducers as appReducers } from '@telstra-connect/ops-hub/reducers';
import { IFeatureFlags as IOpsHubFlags } from '@telstra-connect/ops-hub/feature-flags/common';
import { setFeatureFlags } from '@apps-config/feature-flags';
import type { IReducersMap } from '@telstra-connect/standard-actions/reducers';
import type { IOpsHubState } from '@telstra-connect/ops-hub/state';
import { appName } from '@telstra-connect/utils/data/ops-hub'

enableLogging();

function getApplication() {
  setFeatureFlags();
  return Application;
}

function getReducer(): IReducersMap<IOpsHubState> {
  return appReducers as unknown as IReducersMap<IOpsHubState>;
}

type TGetSessionDetails = () => { sessionId: string; };
interface IApplications {
  [appName]?: IOpsHubFlags,
}

declare const global: {
  TCONN: {
    getSessionDetails: TGetSessionDetails;
    Platform: {
      isSecureAuth: boolean;
      resolveTargetURL: (targetURL: string) => string;
    },
    OpsHub: {
      GetApplication: () => IApplicationDefinition;
      GetReducers: () => IReducersMap<IOpsHubState>;
    };
  };
  applications: IApplications;
};

global.TCONN = { ...global.TCONN };
global.TCONN.OpsHub = {
  GetApplication: getApplication,
  GetReducers: getReducer
};

export default global;
